module.exports = {
  tracking: {
    pauseModalPrefix: 'SUBSCRIPTION_PAUSE_MODAL_',
  },
}
